import { LICENSE_TYPE, TRAINER_TYPE } from "types/transfer/transfer.interface";
import { demoTrainerPhoto } from "./demoImages";
import { createMockListPage } from "./listingMocks";
import {
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  DEMO_ACADEMY_WOMEN_ID,
  matchesAcademyIds,
  matchesMaxDistance,
  matchesOptionalNumber,
} from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID } from "./mockPlayers";
import { demoApi } from "./demoLocale";

export type MockTrainer = {
  TrainerId: string;
  Name: string;
  PhotoFilePath: string;
  GroupName: string;
  Type: TRAINER_TYPE;
  LicenseType: LICENSE_TYPE;
  Distance?: number;
  Academy: {
    AcademyId: string;
    Name: string;
  };
};

export const mockTrainers: MockTrainer[] = [
  {
    TrainerId: "00000000-0000-0000-0000-000000000201",
    Name: "Marek Lewandowski",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000201"),
    GroupName: "Pierwsza drużyna",
    Type: TRAINER_TYPE["Trener"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 8,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000202",
    Name: "Tomasz Kamiński",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000202"),
    GroupName: "Rezerwy",
    Type: TRAINER_TYPE["Skaut"],
    LicenseType: LICENSE_TYPE["UEFA_PRO"],
    Distance: 15,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000203",
    Name: "Krzysztof Zieliński",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000203"),
    GroupName: "U17",
    Type: TRAINER_TYPE["Menager"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 22,
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000504",
    Name: "Alan Michalski",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000504"),
    GroupName: "Trampkarz 2014",
    Type: TRAINER_TYPE["Trener"],
    LicenseType: LICENSE_TYPE["UEFA_PRO"],
    Distance: 5,
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000505",
    Name: "Dominik Król",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000505"),
    GroupName: "Młodzik 2013",
    Type: TRAINER_TYPE["Analityk"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 12,
    Academy: { AcademyId: DEMO_ACADEMY_SOUTH_ID, Name: "Oddział Akademii - Zachodni" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000604",
    Name: "Paweł Nowicki",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000604"),
    GroupName: "Smyki",
    Type: TRAINER_TYPE["Trener"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 7,
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000605",
    Name: "Bartłomiej Lis",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000605"),
    GroupName: "Orlik 2014",
    Type: TRAINER_TYPE["Skaut"],
    LicenseType: LICENSE_TYPE["UEFA_PRO"],
    Distance: 11,
    Academy: { AcademyId: DEMO_ACADEMY_SOUTH_ID, Name: "Oddział Akademii - Zachodni" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000606",
    Name: "Kamil Orłowski",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000606"),
    GroupName: "Trampkarz",
    Type: TRAINER_TYPE["Menager"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 9,
    Academy: { AcademyId: DEMO_ACADEMY_WOMEN_ID, Name: "Sekcja kobieca" },
  },
  {
    TrainerId: "00000000-0000-0000-0000-000000000607",
    Name: "Sebastian Maj",
    PhotoFilePath: demoTrainerPhoto("00000000-0000-0000-0000-000000000607"),
    GroupName: "Młodzik",
    Type: TRAINER_TYPE["Analityk"],
    LicenseType: LICENSE_TYPE["UEFA"],
    Distance: 14,
    Academy: { AcademyId: DEMO_ACADEMY_WOMEN_ID, Name: "Sekcja kobieca" },
  },
];

const trainerFilters = [
  (trainer: MockTrainer, pageInfo: any) => matchesAcademyIds(trainer.Academy?.AcademyId, pageInfo),
  (trainer: MockTrainer, pageInfo: any) =>
    matchesOptionalNumber(trainer.LicenseType, pageInfo.LicenseType),
  (trainer: MockTrainer, pageInfo: any) =>
    matchesOptionalNumber(trainer.Type, pageInfo.TrainerType),
  (trainer: MockTrainer, pageInfo: any) => matchesMaxDistance(trainer.Distance, pageInfo.Area),
];

export const getMockTrainersPage = demoApi((pageInfo: any) =>
  createMockListPage(mockTrainers, pageInfo, {
    search: (trainer, search) => trainer.Name.toLowerCase().includes(search),
    filters: trainerFilters,
  }));
